export enum EntityCreationApproach {
  Manual,
  JSON,
}
